<div class="white-screen">
  <h2>Congrats !</h2>

  <div>
    <p class="subtitle" *ngIf="isLaunchAction">
      You've successfully set up your store!<br />
      To access your store management dashboard and start tracking,<br />
      please complete the registration form below.
    </p>

    <p class="subtitle" *ngIf="!isLaunchAction">
      You've successfully set up your store!<br />
      To access your store management dashboard and launch store,
      please complete the registration form below.
    </p>

    <form class="form-container" [formGroup]="storeDetailForm" >

      <!-- Full Name when NOT launch -->
      <!-- <div class="form-group" *ngIf="!isLaunchAction">
        <div class="input-block">
          <label>Full Name</label>
          <input type="text" placeholder="Enter Full Name" formControlName="fullName" />
          <mat-error
            *ngIf="storeDetailForm.get('fullName')?.hasError('required') && storeDetailForm.get('fullName')?.touched">
            Full Name is required
          </mat-error>
        </div>
      </div> -->

      <!-- First & Last Name only for launch -->
      <div class="form-group">
        <div class="input-block">
          <label>First Name</label>
          <input type="text" placeholder="Enter Your First Name" formControlName="firstName" />
          <mat-error
            *ngIf="storeDetailForm.get('firstName')?.hasError('required') && storeDetailForm.get('firstName')?.touched">
            First Name is required
          </mat-error>
        </div>
        <div class="input-block">
          <label>Last Name</label>
          <input type="text" placeholder="Enter Your Last Name" formControlName="lastName" />
          <mat-error
            *ngIf="storeDetailForm.get('lastName')?.hasError('required') && storeDetailForm.get('lastName')?.touched">
            Last Name is required
          </mat-error>
        </div>
      </div>

      <!-- Store Name only for launch -->
      <div class="form-group">
        <div class="input-block" *ngIf="isLaunchAction">
          <label>Store Name</label>
          <input type="text" placeholder="Enter Store Name" formControlName="name" />
          <mat-error *ngIf="storeDetailForm.get('name')?.hasError('required') && storeDetailForm.get('name')?.touched">
            Store Name is required
          </mat-error>
        </div>

        <div class="input-block">
          <label>Market/ Audience</label>
          <select formControlName="marketId">
            <!-- [attr.readonly]="storeDetailForm.get('marketId')?.value ? true : false"
            [attr.disabled]="!storeDetailForm.get('marketId')?.value ? null : true" -->
            <option value="">Select Market/ Audience</option>
            <option *ngFor="let market of markets" [value]="market.id">{{ market.name }}</option>
          </select>
          <mat-error
            *ngIf="storeDetailForm.get('marketId')?.hasError('required') && storeDetailForm.get('marketId')?.touched">
            Market/Audience is required
          </mat-error>
        </div>
      </div>

      <!-- Phone Number & State/Region -->
      <div class="form-group">
        <div class="input-block">
          <label>Phone number</label>
          <input type="text" placeholder="Enter Phone Number" formControlName="phoneNumber" />
          <mat-error
            *ngIf="storeDetailForm.get('phoneNumber')?.hasError('required') && storeDetailForm.get('phoneNumber')?.touched">
            Phone Number is required
          </mat-error>
        </div>
        <div class="input-block">
          <label>State/ Region</label>
          <select formControlName="userStateRegion">
            <option value="">Select State</option>
            <option *ngFor="let state of states" [value]="state.code">{{ state.name }}</option>
          </select>
          <mat-error
            *ngIf="storeDetailForm.get('userStateRegion')?.hasError('required') && storeDetailForm.get('userStateRegion')?.touched">
            State/Region is required
          </mat-error>
        </div>
      </div>

      <!-- Shipment Method (radio) only for launch -->
      <div class="col-12 mb-2 d-flex flex-column" *ngIf="isLaunchAction">
        <label class="label-sty mb-2">Shipment Method</label>

        <div class="cutom-input-sty radio-sty row" [formGroup]="storeDetailForm">
          <div class="col-12 col-md-4 mb-2">
            <label class="d-flex align-items-center">
              <input type="radio"  formControlName="shippingPreference" value="1" class="mr-1" />
              Individual Shipping
              <mat-icon matTooltip="Orders will be shipped directly to each purchaser" matTooltipPosition="above"
                class="ml-1">info</mat-icon>
            </label>
          </div>

          <div class="col-12 col-md-4 mb-2">
            <label class="d-flex align-items-center">
              <input type="radio" formControlName="shippingPreference" value="2" class="mr-1" />
              Bulk Shipping
              <mat-icon matTooltip="The individually sorted orders will be shipped to you to pass out to your group"
                matTooltipPosition="above" class="ml-1">info</mat-icon>
            </label>
          </div>

          <div class="col-12 col-md-4 mb-2">
            <label class="d-flex align-items-center">
              <input type="radio" formControlName="shippingPreference" value="3" class="mr-1" />
              Bulk Pickup
              <mat-icon
                matTooltip="You will be able to pick up the individually sorted orders to pass out to your group"
                matTooltipPosition="above" class="ml-1">info</mat-icon>
            </label>
          </div>

          <mat-error
            *ngIf="storeDetailForm.get('shippingPreference')?.hasError('required') && storeDetailForm.get('shippingPreference')?.touched">
            Shipment Method is required
          </mat-error>

        </div>
        <!-- Address for bulk shipping or pickup -->
        <div class="row m-2"
          *ngIf="storeDetailForm.get('shippingPreference')?.value === '2' || storeDetailForm.get('shippingPreference')?.value === '3'">

          <div class="col-md-6 d-flex flex-column mb-2">
            <label class="label-sty">Street Address</label>
            <input [readonly]="isBulkPickup" type="text" class="cutom-input-sty" formControlName="shipToAddress"
              placeholder="Enter Street Address" />
            <mat-error
              *ngIf="storeDetailForm.get('shipToAddress')?.hasError('required') && storeDetailForm.get('shipToAddress')?.touched">
              Address is required
            </mat-error>
          </div>

          <div class="col-md-6 d-flex flex-column mb-2">
            <label class="label-sty">Apt, Suite, Unit</label>
            <input [readonly]="isBulkPickup" type="text" class="cutom-input-sty" formControlName="shipToAddress1"
              placeholder="Enter Apt, Suite, Unit" />
          </div>

          <div class="col-md-4 d-flex flex-column mb-2">
            <label class="label-sty">City</label>
            <input [readonly]="isBulkPickup" type="text" class="cutom-input-sty" formControlName="shipToCity"
              placeholder="Enter City" />
            <mat-error
              *ngIf="storeDetailForm.get('shipToCity')?.hasError('required') && storeDetailForm.get('shipToCity')?.touched">
              City is required
            </mat-error>
          </div>

          <div class="col-md-4 d-flex flex-column mb-2">
            <label class="label-sty">State</label>
            <select [disabled]="isBulkPickup" class="cutom-input-sty" formControlName="shipToState">
              <option value="">Select State</option>
              <option *ngFor="let state of states" [value]="state.id"
                [disabled]="isBulkPickup && storeDetailForm.get('shipToState')?.value !== state.id">
                {{ state.name }}
              </option>
            </select>
            <mat-error
              *ngIf="storeDetailForm.get('shipToState')?.hasError('required') && storeDetailForm.get('shipToState')?.touched">
              State is required
            </mat-error>
          </div>

          <div class="col-md-4 d-flex flex-column mb-2">
            <label class="label-sty">Postal Code</label>
            <input [readonly]="isBulkPickup" type="text" class="cutom-input-sty" formControlName="shipToZipCode"
              placeholder="Enter Postal Code" />
            <mat-error
              *ngIf="storeDetailForm.get('shipToZipCode')?.hasError('required') && storeDetailForm.get('shipToZipCode')?.touched">
              Postal Code is required
            </mat-error>
          </div>
        </div>
      </div>

      <!-- <div class="col-12 mb-2 d-flex flex-column" *ngIf="isLaunchAction">
        <label class="label-sty mb-2">Fundraiser</label>
      
        <div class="cutom-input-sty radio-sty row" [formGroup]="storeDetailForm">
          <div class="col-12 col-md-4 mb-2">
            <label class="d-flex align-items-center">
              <input type="radio" formControlName="fundRaisingClaimPreference" value="false" class="mr-1" />
              No
            </label>
          </div>
      
          <div class="col-12 col-md-4 mb-2">
            <label class="d-flex align-items-center">
              <input type="radio" formControlName="fundRaisingClaimPreference" value="true" class="mr-1" />
              Yes
            </label>
          </div> 
           
        </div>
      
        <mat-error
          *ngIf="storeDetailForm.get('fundRaisingClaimPreference')?.hasError('required') && storeDetailForm.get('fundRaisingClaimPreference')?.touched">
          Fundraiser is required
        </mat-error>
       
         
      </div> -->

      <!-- Terms -->
      <div class="form-group checkbox">
        <label>
          <input type="checkbox" (change)="termsChanged()" formControlName="agreeToTerms" />
          By clicking "Complete", I agree to the
          <a [href]="wpUrl + '/terms-and-service'" target="_blank" rel="noopener noreferrer">terms of service</a>.
          <br />
          <mat-error
            *ngIf="storeDetailForm.get('agreeToTerms')?.hasError('required') && storeDetailForm.get('agreeToTerms')?.touched">
            You must agree to the terms
          </mat-error>
        </label>
      </div>

      <!-- Submit -->
      <button type="button" (click)="submitForm()" class="primary-btn">
        Complete And View Store Dashboard
      </button>

    </form>
  </div>

  <!-- <p *ngIf="!isNewUser && isLaunchAction" class="success-text">
    You've successfully set up your store!<br />
    To access your store management dashboard, please go to<br />
    <a (click)="goToMyStore()" class="blue-link">My Account/My Stores</a>
  </p>

  <p *ngIf="!isNewUser && !isLaunchAction" class="success-text">
    You've successfully saved your store!<br />
    To access your draft store dashboard, please go to<br />
    <a (click)="goToMyStore()" class="blue-link">My Account/My Stores</a>
  </p>

  <div *ngIf="!isNewUser" class="button-group">
    <button href="" class="secondary-btn">Back To Home Page</button>
    <button (click)="goToMyStore()" class="primary-btn">My Stores</button>
  </div> -->

</div>